import React, { Component } from 'react';
import get from 'lodash/get';

import Input from '../../../components/UI/CustomInputField';
import css from './SSN.module.scss';
import WidgetPropTypes from '../types';
import { fccFlows } from '../../App/constants';
import { isUSTimezone } from '../../../helpers';

export const WIDGET_NAME = 'set_user_ssn_last4';

class SSN extends Component {
  constructor() {
    super();

    this.state = {
      ssn: '',
      error: false
    };
  }

  componentDidMount() {
    this.props.analytics.trackEvent('Registration Send Card Viewed');

    if (get(this.props, 'app.prefilledAnswers.setUserSsnLast4')) {
      this.setState({
        ssn: this.props.app.prefilledAnswers.setUserSsnLast4
      });
      this.props.shouldEnable(this.props.widget, true);
      this.props.changeAnswerValue(
        this.props.widget,
        this.props.app.prefilledAnswers.setUserSsnLast4
      );
    }
  }

  onChange = value => {
    if (/^\d*$/.test(value)) {
      this.setState({ ssn: value });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const { widget, shouldEnable } = this.props;
    if (this.state !== prevState) {
      if (this.state.ssn.length > 3) {
        shouldEnable(widget, true);
      } else {
        shouldEnable(widget, false);
      }
    }
  }

  errorChecking = async () => {
    if (this.props.toggles.preventNonUSTimezones.enabled && !isUSTimezone()) {
      this.props.analytics.trackEvent('Non-US Timezone Declined', {
        eventProps: {
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }
      });
      this.props.history.replace('/verify-hard-declined');
      throw new Error();
    }
  };

  render() {
    const { changeAnswerValue, widget, app } = this.props;

    return (
      <div className={css.socialSecurity}>
        <Input
          id="ssnId"
          placeholder="Last 4 of your SSN"
          error={this.state.error && !this.state.ssn}
          autoComplete="off"
          autoCorrect="off"
          inputMode="numeric"
          pattern="[0-9]*"
          onClick={this.props.onClick}
          type="tel"
          value={this.state.ssn}
          onChange={value => {
            this.onChange(value);
            changeAnswerValue(widget, value);
          }}
          format={
            fccFlows.indexOf(app.flowId) === -1 &&
            'Don’t worry, we don’t run a credit check.'
          }
          maxLength={4}
          className="fs-mask"
          data-e2e="ssn"
        />
      </div>
    );
  }
}

SSN.propTypes = {
  changeAnswerValue: WidgetPropTypes.changeAnswerValue.isRequired,
  index: WidgetPropTypes.index.isRequired,
  onClick: WidgetPropTypes.onClick.isRequired,
  shouldEnable: WidgetPropTypes.shouldEnable.isRequired,
  widget: WidgetPropTypes.widget.isRequired
};

export default SSN;
